module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-11-7310fd89edf596e759b24cec853086fa.jpg";